import Vue from 'vue'
import Vuex from 'vuex'
import snSigningRoomService from '../services/snSigningRoomService'
import snToastService from '~/services/snToastService'
import Cookies from 'js-cookie'

Vue.use(Vuex)
if (['development', 'staging'].includes(process.env.RAILS_ENV)) {
  Vue.config.devtools = true
}

export const store = new Vuex.Store({
  state: () => ({
    _appInitialized: false,
    _headerText: '',
    _subtitleText: '',
    _headerTabs: [],
    _activeHeaderTab: '',
    _breadcrumbs: [],
    _toasts: [],
    _user: { loading: true },
    _showHeaderLoaderSkeleton: false,
    _isStaging: Cookies.get('srm_is_staging') === 'true',
    _viewAsCompany: null,
    _orgId: Cookies.get('srm_org_id'),
    _timeoutModalTimeout: null,
    _timeoutModalVisible: false,
    _loaderVisible: false,
    _profileSettingsVisible: false,
    _profileSettingsInitialTab: 0
  }),
  getters: {
    appInitialized (state) {
      return state._appInitialized
    },
    headerText (state) {
      return state._headerText
    },
    subtitleText (state) {
      return state._subtitleText
    },
    breadcrumbs (state) {
      return state._breadcrumbs
    },
    headerTabs (state) {
      return state._headerTabs
    },
    activeHeaderTab (state) {
      return state._activeHeaderTab
    },
    toasts (state) {
      return state._toasts
    },
    user (state) {
      return state._user
    },
    showHeaderLoaderSkeleton (state) {
      return state._showHeaderLoaderSkeleton
    },
    isStaging (state) {
      return state._isStaging
    },
    viewAsCompany (state) {
      return state._viewAsCompany
    },
    orgId (state) {
      return state._orgId
    },
    timeoutModalVisible (state) {
      return state._timeoutModalVisible
    },
    loaderVisible (state) {
      return state._loaderVisible
    },
    profileSettingsVisible (state) {
      return state._profileSettingsVisible
    },
    profileSettingsInitialTab (state) {
      return state._profileSettingsInitialTab
    }
  },
  mutations: {
    setAppInitialized (state, newValue) {
      state._appInitialized = newValue
    },
    setHeaderText (state, newHeaderText) {
      if (typeof newHeaderText === 'string') {
        state._headerText = newHeaderText.replaceAll('_', ' ')
      } else {
        state._headerText = newHeaderText
      }
    },
    setSubtitleText (state, newSubtitleText) {
      if (typeof newSubtitleText === 'string') {
        state._subtitleText = newSubtitleText.replaceAll('_', ' ')
      } else {
        state._subtitleText = newSubtitleText
      }
    },
    setBreadcrumbs (state, newBreadcrumbs) {
      if (newBreadcrumbs.length) {
        newBreadcrumbs[newBreadcrumbs.length - 1].disabled = true
      }
      state._breadcrumbs = newBreadcrumbs
    },
    setHeaderTabs (state, newHeaderTabs) {
      if (newHeaderTabs == null || newHeaderTabs === '') {
        newHeaderTabs = []
      }
      state._headerTabs = newHeaderTabs
    },
    setActiveHeaderTab (state, newActiveHeaderTab) {
      state._activeHeaderTab = newActiveHeaderTab
    },
    setIsStaging (state, value) {
      Cookies.set('srm_is_staging', value)
      state._isStaging = value
    },
    becomeCompany (state, company) {
      if (company == null) {
        sessionStorage.removeItem('srm_view_as_company_guid')
      } else {
        sessionStorage.setItem('srm_view_as_company_guid', company.guid)
      }
      state._viewAsCompany = company
    },
    setToast (state, newToast) {
      return snToastService.setToast(state, newToast)
    },
    setSuccessToast (state, { message = 'Success', description = '', type = 'simple' }) {
      return snToastService.setSuccessToast(state, { message, description, type })
    },
    setInfoToast (state, { message = 'Information', description = '', type = 'simple' }) {
      return snToastService.setInfoToast(state, { message, description, type })
    },
    setErrorToast (state, { message = 'Error', description = '', type = 'sticky' }) {
      return snToastService.setErrorToast(state, { message, description, type })
    },
    setWarningToast (state, { message = 'Warning', description = '', type = 'sticky' }) {
      return snToastService.setWarningToast(state, { message, description, type })
    },
    setErrorToastType (state, { message = 'Error', description = '', type = '', actionText = '', actionData = {} }) {
      return snToastService.setErrorToastType(state, { message, description, type, actionText, actionData })
    },
    setUser (state, user) {
      const productionEnabled = snSigningRoomService.hasPermission(user, 'productionEnabled')
      const stagingEnabled = snSigningRoomService.hasPermission(user, 'stagingEnabled')

      if (productionEnabled && !stagingEnabled) {
        state._isStaging = false
      } else if (stagingEnabled && !productionEnabled) {
        state._isStaging = true
      }
      user.loading = false
      state._user = user
    },
    setShowHeaderLoaderSkeleton (state, value) {
      state._showHeaderLoaderSkeleton = value
    },
    setOrgId (state, value) {
      if (value == null) {
        Cookies.remove('srm_org_id')
      } else {
        Cookies.set('srm_org_id', value)
      }
      state._orgId = value
    },
    resetAppTimeout (state, minutesRemaining) {
      const warningModalTime = minutesRemaining ? Math.floor(minutesRemaining * 60000) : 10 * 60000

      state._timeoutModalVisible = false

      clearTimeout(state._timeoutModalTimeout)
      state._timeoutModalTimeout = setTimeout(() => {
        state._timeoutModalVisible = true
      }, warningModalTime)
    },
    setTimeoutModalVisible (state, visible) {
      state._timeoutModalVisible = visible
    },
    setLoaderVisible (state, value) {
      state._loaderVisible = value
    },
    setProfileSettingsVisible (state, visible) {
      state._profileSettingsVisible = visible
    },
    setProfileSettingsInitialTab (state, newInitialTab) {
      state._profileSettingsInitialTab = newInitialTab
    }
  }
})
